import { AbilityBuilder, createMongoAbility } from '@casl/ability';
import type { RawRuleOf } from '@casl/ability';
import type { CompanySettingsAccessContext } from '@/abilities/companySettings/context';
import { COMPANY_SETTINGS_DESTINATION, type CompanySettingsAbility } from '@/abilities/companySettings/vocabulary';

export const companySettingsIntegrationsRules = ({
  isAdmin,
  hasFinancialDocuments,
}: Pick<CompanySettingsAccessContext, 'isAdmin' | 'hasFinancialDocuments'>): RawRuleOf<CompanySettingsAbility>[] => {
  const { can, rules } = new AbilityBuilder<CompanySettingsAbility>(createMongoAbility);
  if (isAdmin) {
    can('see', COMPANY_SETTINGS_DESTINATION, { destination: 'integrations' });
    if (hasFinancialDocuments) can('open', COMPANY_SETTINGS_DESTINATION, { destination: 'integrations' });
  }
  return rules;
};
